import React from 'react'
import Center from '../../components/templates/Center'
import createCenter from '../../domain/useCases/center/createCenter'
import logger from '../../utils/logger'
import PageNotFound from '../../pages/404'

const StubCenter = (props) => {
  if (props.serverData.error) {
    return <PageNotFound />
  }
  const centerProps = {
    ...props,
    locationData: {
      ...props.serverData.location
    },
    center: { ...props.serverData.center, pid: props.serverData.center.id },
    reviews: props.serverData.reviews,
    ourCenters: props.serverData.ourCenters,
    ignorePpv: true,
    isCenterPath: true
  }

  return <Center {...centerProps} />
}

export default StubCenter

export const getServerData = async (props) => {
  try {
    const { slug } = props.params

    const API_HOST = process.env.API_HOST
    const RP_API_KEY = process.env.RP_API_KEY
    const CACHE_PREFIX = process.env.CACHE_PREFIX
    const CENTER_API_URL = `${API_HOST}/api/v2/center/${slug}?key=${RP_API_KEY}&cache_prefix=${CACHE_PREFIX}`

    const { data: center } = await fetch(CENTER_API_URL).then((res) =>
      res.json()
    )

    if (!center) {
      const message = `Center with slug ${props.params.slug} not found`
      logger.log({
        message,
        data: props
      })
      return {
        status: 404,
        headers: {},
        props: {
          error: {
            message
          }
        }
      }
    }

    return {
      status: 200,
      headers: {
        'Cache-Control':
          'public, s-maxage=3600, stale-while-revalidate=86400, durable'
      },
      props: {
        location: {},
        center: createCenter(center),
        reviews: [],
        ourCenters: []
      }
    }
  } catch (error) {
    const message = `Error getServerData fetching center ${props.params.slug}`

    logger.error({
      message,
      error
    })

    return {
      status: 404,
      headers: {},
      props: {
        error: {
          message
        }
      }
    }
  }
}
